import { projectDataType } from ".";

const tundraData: projectDataType = {
  path: "dreamspacetundra",
  title: "Tundra Dreamspace",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965409/Art-Site/Tundra/tundra-main.jpg",
  description: "VR installation of Tundra.",
  year: 2017,
  link: "http://www.dream-space.net/artists/zatonyl/",
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965409/Art-Site/Tundra/tundra-main.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965409/Art-Site/Tundra/tundra-main-2.jpg",
  ],
  installPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1685030700/Art-Site/Tundra/Tundra-01.png",
  ],
};

export default tundraData;
